var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelva(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.7395 97.479H81.7143V64.7731C81.2941 64.8067 80.8739 64.8236 80.4538 64.8236C80.0336 64.8236 79.6134 64.8067 79.1933 64.7731V97.479H51.2605V79.4454C50.8403 79.479 50.4202 79.4958 50 79.4958C49.5798 79.4958 49.1597 79.479 48.7395 79.4454V97.479H20.8067V64.7731C20.3866 64.8067 19.9664 64.8236 19.5462 64.8236C19.1261 64.8236 18.7059 64.8067 18.2857 64.7731V97.479H1.2605C0.564706 97.479 0 98.0437 0 98.7395C0 99.4353 0.564706 100 1.2605 100H98.7395C99.4353 100 100 99.4353 100 98.7395C100 98.0437 99.4353 97.479 98.7395 97.479Z",
    fill: "url(#paint0_linear_1939_68)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.874 62.2858C42.3866 61.7984 42.3866 61.0084 42.874 60.5042C43.3782 60.0169 44.1681 60.0169 44.6555 60.5042L48.7395 64.5883V57.4958C48.7395 56.79 49.3109 56.2353 50 56.2353C50.6891 56.2353 51.2605 56.79 51.2605 57.4958V79.4454C61.563 78.8067 69.7479 70.2185 69.7479 59.7479C69.7479 48.8572 60.8908 40.0001 50 40.0001C39.1092 40.0001 30.2521 48.8572 30.2521 59.7479C30.2521 70.2185 38.437 78.8067 48.7395 79.4454V68.1513L42.874 62.2858Z",
    fill: "url(#paint1_linear_1939_68)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3277 38.5882C72.8403 38.084 72.8403 37.2941 73.3277 36.8067C73.8319 36.3025 74.6218 36.3025 75.1092 36.8067L79.1932 40.8739V33.7815C79.1932 33.0756 79.7478 32.521 80.4537 32.521C81.1428 32.521 81.7142 33.0756 81.7142 33.7815V49.6638L88.3529 43.0252C88.8403 42.5378 89.647 42.5378 90.1344 43.0252C90.6218 43.5126 90.6218 44.3193 90.1344 44.8067L81.7142 53.2269L81.7143 64.7731C91.8992 64.1345 99.9999 55.6302 99.9999 45.2773C99.9999 36.521 92.2016 0 80.4537 0C70.2352 0 62.9915 27.647 61.2941 40.5882C67.8487 44.4706 72.2689 51.5966 72.2689 59.7479C72.2689 60.8235 72.168 61.8655 72.0168 62.8907C74.2184 63.9495 76.6387 64.6219 79.1933 64.7731L79.1932 44.4369L73.3277 38.5882Z",
    fill: "url(#paint2_linear_1939_68)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.437 38.5882C11.9328 38.084 11.9328 37.2941 12.437 36.8067C12.9244 36.3025 13.7143 36.3025 14.2185 36.8067L18.2857 40.8739V33.7815C18.2857 33.0756 18.8571 32.521 19.5462 32.521C20.2521 32.521 20.8067 33.0756 20.8067 33.7815V49.6638L27.4454 43.0252C27.9496 42.5378 28.7395 42.5378 29.2269 43.0252C29.7311 43.5126 29.7311 44.3193 29.2269 44.8067L20.8067 53.2269V64.7731C23.3613 64.6219 25.7815 63.9495 27.9832 62.8907C27.8319 61.8655 27.7311 60.8235 27.7311 59.7479C27.7311 51.5966 32.1513 44.4706 38.7059 40.5882C37.0084 27.647 29.7647 0 19.5462 0C7.79832 0 0 36.521 0 45.2773C0 55.6302 8.10084 64.1345 18.2857 64.7731V44.4369L12.437 38.5882Z",
    fill: "url(#paint3_linear_1939_68)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1939_68",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1939_68",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1939_68",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1939_68",
    x1: 0.00282997,
    y1: 49.9927,
    x2: 100.011,
    y2: 49.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelva);
export default __webpack_public_path__ + "static/media/selva.612f17b17090cce6ae8ebb8f7ffa23ec.svg";
export { ForwardRef as ReactComponent };